import React, { useState, useEffect } from 'react';
import Heart from '../components/Icons/IconHeart';
import HeartAnimation from '../components/Anim/HeartAnimation';

const CheckoutButtonPage = ({ animationDelay = 1000 }) => {
  const [animationComplete, setAnimationComplete] = useState(true);
  const [startAnimation, setStartAnimation] = useState(false);

  const handleClick = () => {
    setStartAnimation(false);
    setAnimationComplete(false);
  };

  useEffect(() => {
    let timer;
    if (!animationComplete) {
      timer = setTimeout(() => {
        setStartAnimation(true);
      }, animationDelay); // delay before starting animation, default 1000ms
    }
    return () => clearTimeout(timer);
  }, [animationComplete, animationDelay]);

  return (
    <div id="heartWrapper" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
      {!animationComplete && startAnimation && <HeartAnimation onAnimationComplete={() => setAnimationComplete(true)} />}
      <button className="btn match-sold-btn z99s o-o" onClick={handleClick}>
        &nbsp;  &nbsp;
      </button>
    </div>
  );
};

export default CheckoutButtonPage;
